import type { ReactNode } from 'react';
import { ROLE_ADMIN } from '@app/shared';
import { useAuth } from './AuthProvider';

// Client-side route guard. Server still enforces authorization; this is a UX courtesy.
// Admins always pass regardless of the required role.
export function RoleGuard({
  role,
  children,
  fallback,
}: {
  role?: string;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { me, loading, login } = useAuth();

  if (loading) return <p>Loading…</p>;

  if (!me) {
    return (
      fallback ?? (
        <div>
          <p>Sign in to continue.</p>
          <button onClick={() => void login()}>Sign in</button>
        </div>
      )
    );
  }

  const isAdmin = me.roles.includes(ROLE_ADMIN);
  if (role && !isAdmin && !me.roles.includes(role)) {
    return fallback ?? <p className="access-denied">Access denied: this page requires the <code>{role}</code> role.</p>;
  }

  return <>{children}</>;
}
